import { QuickSocialExportSettings } from '@app/modules/social-export/components/settings/QuickSocialExportSettings';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { usePublishRestriction } from '@app/modules/social-export/hooks/usePublishRestriction';
import { useSocialExportConnectedForStation } from '@app/modules/social-export/hooks/useSocialExportConnectedForStation';
import { PublishRestrictionWarning } from '@app/modules/social-export/publish/PublishRestrictionWarning';
import { Box, Tooltip } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useWatch } from 'react-hook-form-mui';
import { PublishToggleCard } from './PublishToggleCard';

export function QuickPlatformUploadFields({
  stationId,
  platform,
  durationMs,
}: {
  stationId: string;
  platform: SocialPlatform;
  durationMs?: number;
}) {
  const { setValue } = useFormContext();
  const enabled = useSocialExportConnectedForStation(stationId, platform);
  const isOn = useWatch({ name: `platformUpload.${platform.id}.enabled` });
  const restrictionMessage = usePublishRestriction(platform, { durationMs });
  const isRestricted = Boolean(restrictionMessage);

  useEffect(() => {
    if (isRestricted) {
      setValue(`platformUpload.${platform.id}.enabled`, false);
    }
  }, [isRestricted, platform.id, setValue]);

  if (!enabled) return null;

  const card = (
    <PublishToggleCard
      icon={platform.Icon({ fontSize: 'small', colored: true })}
      label={
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {platform.name}
          {restrictionMessage ? <PublishRestrictionWarning /> : null}
        </Box>
      }
      switchName={`platformUpload.${platform.id}.enabled`}
      disabled={isRestricted}
    >
      {isOn && (
        <QuickSocialExportSettings
          platform={platform}
          fieldPrefix={`platformUpload.${platform.id}`}
        />
      )}
    </PublishToggleCard>
  );

  if (!restrictionMessage) {
    return card;
  }

  return (
    <Tooltip title={restrictionMessage} placement="left">
      <Box>{card}</Box>
    </Tooltip>
  );
}
